
import { computed, defineComponent, getCurrentInstance, onMounted, watch } from 'vue';
import CodeExampleBody from '@/components/docs-main/code-rails-view/CodeExampleBody.vue';
import { StoreMutations } from '@/templates/DataNames';
import { useCurrentCodeBlock } from '@/heplers/composables';

interface CodeExampleNew {
  id: string;
  title: string;
  kind: string;
  examples: [];
  uniqId: string;
  env: string;
  description?: string;
}

type CodeExample = Map<string, CodeExampleNew>;

export default defineComponent({
  name: 'CodeRails',
  components: {
    CodeExampleBody,
  },
  props: {
    layoutHeight: {
      type: String,
      default: '',
    },
  },
  setup() {
    const instance = getCurrentInstance();
    const store = computed(() => instance?.proxy?.$store);
    const route = instance?.proxy?.$route;

    const { currentCodeExampleId, setCurrentCodeId } = useCurrentCodeBlock();

    const data = computed(() => store.value?.getters?.getContent);

    const computeExamples = (): CodeExample => {
      const contentData = data.value;
      if (!contentData) return new Map();

      let content;
      if (contentData.content) {
        content = contentData.content.filter(
          (item: any) => item.kind === 'content_source' && item.examples?.length
        );
      } else if (contentData.children) {
        content =
          contentData.children
            .filter((method: any) => method.examples?.examples?.length)
            .map((method: any) => ({ uniqId: method.uniqId, ...method.examples })) || [];
      }
      const result = new Map();
      content?.forEach((el: any) => result.set(el.uniqId, { ...el }));
      return result;
    };

    const examples = computed(computeExamples);
    const preparedExamples = computed(() => [...examples.value.values()]);
    const currentExample = computed(() => examples.value.get(currentCodeExampleId.value));

    const setCodeExamples = () => {
      const anchorLink = route?.hash?.replace('#', '');

      if (anchorLink && examples.value.has(anchorLink)) {
        setCurrentCodeId(anchorLink);
      }
    };

    watch(currentExample, (value) => {
      if (value) store.value?.commit(StoreMutations.SET_STATUS_OF_PAGEINCLUDESCODEEXAMPLES, true);
    });

    onMounted(() => {
      setCodeExamples();
    });

    return {
      currentExample,
      examples,
      preparedExamples,
      currentCodeExampleId,
    };
  },
});
